/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireStatusStatusEnum } from './CustomQuestionnaireStatusStatusEnum';
import {
  CustomQuestionnaireStatusStatusEnumFromJSON,
  CustomQuestionnaireStatusStatusEnumFromJSONTyped,
  CustomQuestionnaireStatusStatusEnumToJSON,
} from './CustomQuestionnaireStatusStatusEnum';

/**
 *
 * @export
 * @interface CustomQuestionnaireStatus
 */
export interface CustomQuestionnaireStatus {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireStatus
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireStatus
   */
  name: string;
  /**
   *
   * @type {CustomQuestionnaireStatusStatusEnum}
   * @memberof CustomQuestionnaireStatus
   */
  status: CustomQuestionnaireStatusStatusEnum;
}

/**
 * Check if a given object implements the CustomQuestionnaireStatus interface.
 */
export function instanceOfCustomQuestionnaireStatus(value: object): value is CustomQuestionnaireStatus {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireStatusFromJSON(json: any): CustomQuestionnaireStatus {
  return CustomQuestionnaireStatusFromJSONTyped(json, false);
}

export function CustomQuestionnaireStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireStatus {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    status: CustomQuestionnaireStatusStatusEnumFromJSON(json['status']),
  };
}

export function CustomQuestionnaireStatusToJSON(value?: CustomQuestionnaireStatus | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    name: value['name'],
    status: CustomQuestionnaireStatusStatusEnumToJSON(value['status']),
  };
}
